// AUTO-GENERATED — do not edit.
// Regenerated by scripts/gen-buildinfo.js on every `npm run build`.
const BUILD_INFO = {
  version: "5.0.1",
  buildDate: "2026-10-25T19:53:40.075Z",
};
export default BUILD_INFO;
